import { render, staticRenderFns } from "./image-carousel.vue?vue&type=template&id=5ac8635f"
import script from "./image-carousel.vue?vue&type=script&lang=js"
export * from "./image-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports